var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseChatDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloseChatDesktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESKTOP-CHAT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat-group-expanded-video-copy-3",
    transform: "translate(-1034.000000, -46.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(-21.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(0.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1065.62818,18.1718828 L1062.29525,21.5051869 L1065.62818,24.8383332 C1066.12394,25.3342835 1066.12394,26.1376567 1065.62818,26.6336071 C1065.38048,26.8813138 1065.05572,27.0052619 1064.73112,27.0052619 C1064.40598,27.0052619 1064.08119,26.8815033 1063.83368,26.6336071 L1060.50002,23.3000819 L1057.16661,26.6335755 C1056.91893,26.8812822 1056.59414,27.0052303 1056.26926,27.0052303 C1055.94447,27.0052303 1055.6199,26.8814717 1055.37201,26.6335755 C1054.87625,26.1378462 1054.87625,25.3344414 1055.37201,24.8383016 L1058.70485,21.5051553 L1055.37182,18.1718828 C1054.87606,17.6761219 1054.87606,16.8725592 1055.37182,16.3767983 C1055.86748,15.8814164 1056.67056,15.8814164 1057.16642,16.3767983 L1060.49998,19.7101025 L1063.8333,16.3767983 C1064.32925,15.8814164 1065.13242,15.8814164 1065.62799,16.3767983 C1066.12394,16.8725592 1066.12394,17.6761219 1065.62818,18.1718828 Z",
    id: "icCloseChatDesktop"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseChatDesktop);
export default __webpack_public_path__ + "static/media/icCloseChatDesktop.b8eb16638fdea8fc9a5f457da003deeb.svg";
export { ForwardRef as ReactComponent };